<template>
<div>
  <div class="section_padding_half section_grayBorder">
    <div :class="['careersSearchControls', { careersSearchControls_noSearch: !searchBox }]">
      <div v-for="(options, name) in filterOptions" :key="name">
            <label :for="name" class="isVisuallyHidden">{{name}}</label>
            <div class="select">
                <select :name="name" :id="name" class="select" @change="function(event) { setFilter(name, event.target.value) }">
                    <option value=""> {{name}} </option>
                    <option v-for="option in options" :key="option">{{option}}</option>
                </select>
                <div class="select-icon">
                    <i class="icon icon_dropdownArrow"></i>
                </div>
            </div>
          </div>
          <div v-if='searchBox' class="search">
            <input type="text" autofocus="autofocus" placeholder="Search" name="s" autocomplete="off" class="search-textInput" @input="updateSearchString">
            <div class="search-searchIcon">
                <i class="icon icon_search"></i>
            </div>
          </div>
      </div>
  </div>
</div>
</template>

<script>
export default {
    props: ['filterOptions', 'updateSearchString', 'setFilter', 'searchBox']
}
</script>

